import React, { Component } from 'react';
import '../css/basics/Textfield.css';
import PropTypes from 'prop-types';
// import ReactShadowRoot from 'react-shadow-root';
import ReactTooltip from 'react-tooltip';

class Textfield extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipVisible: true,
    };

    this.classBotonX = 'ui-x clear-btn';
    this.classBotonX = this.props.tooltip
      ? this.classBotonX + ' textfield-cuentas__clear-btn-tooltip'
      : this.classBotonX;

    this.classBotonTooltip = 'ui-info textfield-cuentas__tooltip-textfield';
    this.classBotonTooltip = this.props.tooltip
      ? this.classBotonTooltip + ' textfield-cuentas__tooltip-textfield-visible'
      : this.classBotonTooltip;

    if (this.props.sinMargen) {
      this.margen = 'textfield-cuentas__div-item-no-margin';
    } else {
      this.margen = 'textfield-cuentas__div-item';
    }

    this.inline = '';
    if (this.props.inline) {
      this.inline = 'textfield-cuentas__div-inline';
    }

    this.extraStyles = {};
    if (this.props.extraStyles) this.extraStyles = this.props.extraStyles;

    this.showTooltip = this.showTooltip.bind(this);
  }

  showTooltip() {
    this.setState({ tooltipVisible: !this.state.tooltipVisible });
  }

  onChange2 = (event) => {
    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  };

  componentDidMount() {
    //Textfields.init({ initSelector: '.textfield' });
  }

  disablePaste(e) {
      e.preventDefault();
  }

  render() {
    let className = 'textfield';
    className = this.props.bgcolor ? className + ' input--bg-' + this.props.bgcolor : className;
    className = this.props.readonly ? className + ' input--readonly' : className;
    className = this.props.error ? className + ' input--error' : className;
    className = this.props.small ? className + ' input--height-48' : className;

    let tooltipVisible;
    if (this.state.tooltipVisible) {
      tooltipVisible = 'textfield-cuentas__tooltip-msg';
    } else {
      tooltipVisible = 'textfield-cuentas__tooltip-msg textfield-cuentas__tooltip-msg-hidden';
    }

    let estilosBotonBorrar = '';
    if (this.props.sinBorrado) {
      estilosBotonBorrar = 'textfield-cuentas__always-off';
    }

    let htmlTooltip = '';
    if (this.props.tooltip !== undefined) {
      htmlTooltip = (
        <div>
          <ReactTooltip />
          <span
            className={'' + this.props.icon + ' texfield__tooltip'}
            data-html={true}
            data-tip={this.props.tooltip}
            data-class="tooltip-personalized"
            data-multiline={true}
            data-type="light"
          />
        </div>
      );
    } else {
      htmlTooltip = '';
    }

    let htmlMensajeTextfield = '';
    if (this.props.mensajeTextfield !== undefined) {
      htmlMensajeTextfield = <div className={tooltipVisible}>{this.props.mensajeTextfield}</div>;
    } else {
      htmlMensajeTextfield = '';
    }

    return (
      <div className={'input__wrapper ' + this.inline + ' ' + this.margen}>
        {/* <ReactShadowRoot> */}
        <input
          id={this.props.id}
          className={className + ' textfield-cuentas__div-textfield'}
          disabled={this.props.disabled ? true : false}
          readOnly={this.props.readonly ? true : false}
          required={this.props.required ? true : false}
          data-orden={this.props.orden}
          name={this.props.name}
          style={{ ...this.extraStyles }}
          value={this.props.value}
          onChange={this.onChange2}
          onBlur={this.props.onblur}
          onPaste={this.props.disablePaste && this.disablePaste}
          data-tipopregunta={this.props.dataTipoPregunta}
          data-formato={this.props.dataFormato}
          data-error={this.props.error}
          data-tipodato={this.props.dataTipoDato}
          data-validacion={this.props.dataValidacion}
          maxLength={this.props.maxLength}
          onClick={this.props.onClick}
          bgcolor={this.props.bgcolor}
          inputMode={this.props.inputMode}
          autoComplete={this.props.autoComplete}
          data-errorname={this.props.dataError}
        />
        {/* </ReactShadowRoot> */}
        <label htmlFor={this.props.id} className="input__label">
          {this.props.label}
          <span className="check-valid"> {this.props.check}</span>
        </label>
        <button className={this.classBotonX + ' ' + estilosBotonBorrar} type="button" tabIndex="-1">
          CLEAR INPUT TEXT
        </button>
        {htmlTooltip}
        {htmlMensajeTextfield}
        <div className= {`ui-warning input__error-msg-custom input__error-msg ${this.props.errorCentrado ? 'input__error-centrado' : ''}`}>{this.props.error}</div>
      </div>
    );
  }
}

Textfield.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Textfield;



// WEBPACK FOOTER //
// ./src/basics/Textfield.js